import { Divider, ScrollPanel } from "primereact";
import { StartListCategoryHeader, StartListCategoryRow } from "./StartListRow";
import { useEffect, useState } from "react";

class StartListPerson {
    StartTime = 0;
    Name = "";
    Club = "";
    constructor(s, n, c) {
        this.StartTime = parseInt(s);
        this.Name = n;
        this.Club = c;
    }
}
export default function StartListCategory(props) {
    const [persons2, setPersons2] = useState([]);
    useEffect(() => {
        //console.log("StartListCategory time: ", props.starttime);
        if (props.starttime == null) return;
        let rows = [];
        props.persons.map((el) => {
            rows.push(new StartListPerson(parseInt(el.StartTime) + props.starttime.ToMs(), el.Name, el.Club));
        })
        rows.sort((a, b) => {
            if (a.StartTime < b.StartTime) return -1;
            else if (a.StartTime > b.StartTime) return 1;
            else return 0;
        });
        setPersons2(rows);
        //console.log("set persons : ", props.persons);
    }, [props.persons]);
    return (
        <>
            <div className="flex flex-col h-full ">
                <div className="h-12 text-2xl">
                    Category: <span className="font-bold" >{props?.categoryHeader}</span>
                    <Divider />
                </div>
                <div className="flex-1 p-2">
                    <StartListCategoryHeader />
                    <ScrollPanel className="custombar1 h-full p-2">
                        <div className="grid grid-cols-1 absolute">
                            {
                                persons2.map((el) => (
                                    <StartListCategoryRow person={el} />
                                ))
                            }
                        </div>
                    </ScrollPanel>
                </div >
            </div >
        </>
    )
}